export default {
    workflows: {
        title: "Workflows",
        description: "Manage custom workflows for AI agents",
        newWorkflow: "New Workflow",
        searchPlaceholder: "Search by name...",
        statusPlaceholder: "Filter by status",
        type: {
            default: "Default",
            custom: "Custom",
        },
        status: {
            draft: "Draft",
            analyzing: "Analyzing",
            ready: "Ready",
            needs_clarification: "Needs Review",
            invalid: "Invalid",
            disabled: "Disabled",
            // Legacy (for backwards compatibility)
            active: "Active",
            inactive: "Inactive",
        },
        headers: {
            name: "Name",
            type: "Type",
            status: "AI Status",
            active: "Active",
            nodesCount: "Nodes",
            lastAiEvaluation: "Last AI Validation",
            createdAt: "Created",
            actions: "Actions",
        },
        actions: {
            view: "View",
            edit: "Edit",
            delete: "Delete",
        },
        detail: {
            back: "Back",
            edit: "Edit",
            nodesCount: "Nodes",
            edgesCount: "Edges",
            createdAt: "Created At",
            visualization: "Workflow Visualization",
        },
        notFound: {
            title: "Workflow Not Found",
            message: "The requested workflow does not exist.",
            backToList: "Back to List",
        },
        noData: {
            title: "No Workflows",
            message: "Create your first workflow to get started.",
        },
        modal: {
            confirmDelete: "Delete Workflow",
            confirmDeleteMessage: "Are you sure you want to delete this workflow? This action cannot be undone.",
            defaultWorkflowWarning: {
                title: "Default Workflow",
                message: "You are editing a default workflow. Changes may affect system behavior.",
            },
            deleteDefaultWorkflow: {
                title: "Delete Default Workflow",
                message: "You are about to delete a default workflow. This action may affect system behavior. Are you sure you want to continue?",
            },
        },
        new: {
            title: "New Workflow",
        },
        edit: {
            title: "Edit Workflow",
        },
        editor: {
            addNode: "Add Node",
            deleteNode: "Delete Node",
            cancel: "Cancel",
            save: "Save",
            nodeProperties: "Node Properties",
            nodeType: "Type",
            nodeLabel: "Label",
            agentType: "Agent Type",
            actionType: "Action Type",
            condition: "Condition",
            nodeTypes: {
                start: "Start Node",
                agent: "Agent Node",
                decision: "Decision Node",
                action: "Action Node",
                email: "Email Node",
                end: "End Node",
            },
            defaultLabels: {
                start: "Start",
                agent: "Agent",
                decision: "Decision",
                action: "Action",
                email: "Email",
                end: "End",
            },
            agentTypes: {
                postino: "Postino/Mailer",
                classificatore: "Classifier",
                parser: "Parser",
                validatore: "Validator",
            },
            actionTypes: {
                notification_in_app: "In-App Notification",
                notification_email: "Email Notification",
                notification_both: "Complete Notification",
            },
            operators: {
                equals: "Equals",
                contains: "Contains",
                exists: "Exists",
                not_equals: "Not Equals",
                not_contains: "Not Contains",
            },
            savingWorkflow: "Saving workflow...",
            workflowSaved: "Workflow saved successfully!",
            relatedAccounts: "Related Accounts",
            searchAccounts: "Search accounts by name, email, or tax ID...",
            noAccountsFound: "No accounts found",
            taxId: "Tax ID",
            selectedCount: "{{count}} selected",
            close: "Close",
            instructions: "Instructions (Natural Language)",
            instructionsPlaceholder: "Describe the condition or action in natural language...",
            edgeProperties: "Edge Properties",
            edgeLabel: "Label",
            edgeLabelPlaceholder: "Enter label for the connection...",
            deleteEdge: "Delete Edge",
            closeSidebar: "Close panel",
            openSidebar: "Open panel",
            workflowProperties: "Workflow Properties",
            status: "Status",
            isActive: "Active",
            isDefault: "Default Workflow",
            evaluate: "Evaluate",
            evaluating: "Evaluating...",
            agentDefault: "Default",
            agentSelector: {
                placeholder: "Select an agent...",
                searchPlaceholder: "Search agent by name, description...",
                filters: {
                    all: "All",
                    defaultOnly: "Default only",
                },
                noResults: "No agents found",
                tools: "{{count}} tools",
                ragSources: "{{count}} RAG sources",
            },
            aiFeedback: {
                title: "AI Evaluation Results",
                analyzedAt: "Analyzed at",
                nodeId: "Node",
                suggestions: "Suggestions",
                noFeedback: "No feedback available. Click 'Evaluate' to analyze this workflow.",
            },
            // Start Node - Trigger Configuration
            triggerType: "Trigger Type",
            selectTrigger: "Select a trigger...",
            requiresConditions: "requires conditions",
            triggerConditions: "Trigger Conditions",
            selectValue: "Select a value...",
            startNodeInstruction: "Description",
            startNodeInstructionPlaceholder: "Describe what this workflow does and when it triggers...",
            // Action Node - Actions Configuration
            availableActions: "Available Actions",
            addAction: "Add Action",
            actionOrder: "Order",
            actionParams: "Parameters",
            actionParamsPlaceholder: "Configure action parameters...",
            noActionsConfigured: "No actions configured. Click 'Add Action' to add workflow actions.",
            removeAction: "Remove",
            moveUp: "Move Up",
            moveDown: "Move Down",
            actionCategories: {
                notification: "Notifications",
                logging: "Logging & Activities",
                data_query: "Data Queries",
                document: "Documents",
                tracking: "Tracking",
                external: "External Services",
                delegation: "Delegation",
            },
            dangerousAction: "Dangerous",
            requiresConfirmation: "Requires Confirmation",
            toolAction: "Tool",
            // Email Node
            emailNodeTemplateFilter: "Template filter",
            emailNodeFilterSystem: "System templates only",
            emailNodeFilterCompany: "Templates for company",
            emailNodeSelectTemplate: "Select template",
            emailNodeCompany: "Company",
            emailNodeSelectCompany: "Select company...",
            emailNodeRules: "Rules (Natural Language)",
            emailNodeRulesPlaceholder: "Describe rules to follow for this email send...",
            emailNodeTo: "Recipients (optional)",
            emailNodeToPlaceholder: "e.g. {{context.email_to}} or comma-separated addresses",
        },
        savingChanges: "Saving changes...",
        allSaved: "All saved!",
    },
};
